// Homepage-block chrome that is hardcoded in components (not BE-driven copy).
export const home = {
  en: {
    // ShopMenWomen block social-proof strip ("As featured in" + press logos).
    asFeaturedIn: "As featured in",
    // PressReleaseFeatures ("What the Experts are Saying") block. These are
    // hardcoded MOCK marketing quotes (not a live press feed). Quote BODIES
    // localize; the magazine names + article-title sources stay English — they
    // are real publication/article identifiers, so translating them would
    // invent citations that don't exist.
    expertsHeadline:
      'What the <span class="font-semibold">Experts are Saying</span>',
    expertsDescription:
      "Don't just take our word for it. Have a look at what outdoor gear experts are saying about BÆRSkin products tested in the field",
    pressFeatures: "Press features",
    expertsQuote1:
      "This jacket exudes durability and quality craftsmanship all around, and earns major cool points for not breaking the bank.",
    expertsQuote2:
      "BÆRSkin Tactical Supply has revolutionized outdoor gear with one of the best hoodies in the world.",
    expertsQuote3:
      "The last outer layer you'll ever need, this tactical and stylish hoodie is perfect for outdoor winter adventures.",
    // Default block headlines (CMS fallbacks when no headline is authored).
    bestSellersHeadline: "Shop our Best Sellers",
    newArrivalsHeadline:
      'Explore our <span class="font-semibold">new arrivals</span>',
    faqHeadline: "Frequently asked questions",
    // BestSellers "View more" expand button.
    viewMore: "View more",
    // MailerSignup block (newsletter opt-in).
    mailerThankYou:
      "Thank you for registering! You'll shortly receive a confirmation email from us.",
    mailerSubmit: "Sign Up Now",
    mailerSubmitting: "Signing you up...",
    mailerEmailLabel: "Email Address",
    mailerEmailPlaceholder: "Enter your email address",
    mailerConsentAria: "agree",
    // {name} = brand name, passed through verbatim (rendered bold in the JSX).
    mailerConsent:
      "I agree to receive promotional marketing and emails from {name}",
    // Pagination visible prev/next labels (arrows kept verbatim).
    paginationPrevious: "← Previous",
    paginationNext: "Next →",
    // Breadcrumb default home crumb label.
    breadcrumbHome: "Home",
  },
  de: {
    asFeaturedIn: "Bekannt aus",
    expertsHeadline:
      'Was die <span class="font-semibold">Experten sagen</span>',
    expertsDescription:
      "Verlass dich nicht nur auf unser Wort. Sieh dir an, was Outdoor-Ausrüstungsexperten über BÆRSkin-Produkte sagen, die im Einsatz getestet wurden",
    pressFeatures: "Pressestimmen",
    expertsQuote1:
      "Diese Jacke strahlt rundum Langlebigkeit und hochwertige Verarbeitung aus – und sammelt dabei jede Menge Pluspunkte, ohne das Budget zu sprengen.",
    expertsQuote2:
      "BÆRSkin Tactical Supply hat Outdoor-Ausrüstung revolutioniert – mit einem der besten Hoodies der Welt.",
    expertsQuote3:
      "Die letzte Außenschicht, die du je brauchen wirst: Dieser taktische und stylische Hoodie ist perfekt für winterliche Outdoor-Abenteuer.",
    bestSellersHeadline: "Entdecke unsere Bestseller",
    newArrivalsHeadline:
      'Entdecke unsere <span class="font-semibold">Neuheiten</span>',
    faqHeadline: "Häufig gestellte Fragen",
    viewMore: "Mehr anzeigen",
    mailerThankYou:
      "Danke für deine Anmeldung! Du erhältst in Kürze eine Bestätigungs-E-Mail von uns.",
    mailerSubmit: "Jetzt anmelden",
    mailerSubmitting: "Anmeldung läuft …",
    mailerEmailLabel: "E-Mail-Adresse",
    mailerEmailPlaceholder: "Gib deine E-Mail-Adresse ein",
    mailerConsentAria: "zustimmen",
    mailerConsent:
      "Ich stimme zu, Werbe- und Marketing-E-Mails von {name} zu erhalten",
    paginationPrevious: "← Zurück",
    paginationNext: "Weiter →",
    breadcrumbHome: "Startseite",
  },
} as const
